<template>
    <q-card
        class="productible-card tw-shadow tw-relative hover:tw-shadow-xl tw-transition tw-w-full"
    >
        <q-card-section class="tw-cursor-pointer">
            <div class="tw-flex tw-flex-col lg:tw-flex-row tw-gap-3">
                <q-carousel
                    class="tw-w-full"
                    v-model="slide"
                    infinite
                    autoplay
                    style="max-height: 170px; max-width: 170px"
                    animated
                    transition-next="fade"
                    transition-prev="fade"
                    @click="showProduct"
                >
                    <q-carousel-slide
                        v-if="product.images.length === 0"
                        name="-1"
                        img-src="/img/product_placeholder.png"
                    />
                    <q-carousel-slide
                        class="tw-bg-contain tw-bg-no-repeat"
                        v-for="image in product.images"
                        :name="image.id"
                        :img-src="image.thumb"
                    />
                </q-carousel>

                <div
                    class="tw-flex tw-flex-col tw-justify-between tw-w-full tw-gap-8 lg:tw-gap-0"
                >
                    <div class="tw-w-full tw-h-full" @click="showProduct">
                        <div
                            class="tw-text-ellipsis tw-text-base tw-overflow-hidden tw-text-title tw-font-titles tw-font-semibold tw-tracking-tighter"
                        >
                            {{ product.name }}
                        </div>

                        <ProductLocation
                            :point_of_sale_list="point_of_sale_list"
                            v-if="point_of_sale_list.length > 0"
                        ></ProductLocation>

                        <a class="tw-truncate tw-block tw-text-lg">{{
                            getCategoriesNames(product)
                        }}</a>

                        <ProductPrice
                            class="home-deli-price tw-text-xl"
                            :product="product"
                        />
                    </div>

                    <div class="tw-justify-center" v-if="inStock()">
                        <div
                            class="tw-flex tw-justify-start tw-items-start tw-gap-3 font-body"
                        >
                            <TextInput
                                class="tw-w-1/3 tw-text-lg"
                                v-model="quantity"
                                type="number"
                                min="1"
                                dense
                            />
                            <div>
                                <PrimaryButton
                                    icon="add_shopping_cart"
                                    type="button"
                                    @click.prevent="add"
                                    v-if="product.type === 'simple'"
                                >
                                    {{ $t("actions.add") }}
                                </PrimaryButton>
                            </div>
                        </div>

                        <PrimaryButton
                            icon="visibility"
                            type="button"
                            @click.prevent="showProduct"
                            v-if="product.type === 'variable'"
                        >
                            {{ $t("actions.show_variations") }}
                        </PrimaryButton>
                    </div>
                </div>

                <span
                    class="text-white tw-absolute bg-negative tw-rounded tw-px-1"
                    v-if="!inStock()"
                >
                    {{ $t("messages.out_stock") }}
                </span>

                <span
                    class="text-white tw-absolute bg-primary tw-rounded tw-px-1"
                    :class="{ 'tw-mt-7': !inStock() }"
                    v-if="product.in_offer"
                >
                    {{ $t("fields.in_offer") }}
                </span>
            </div>
        </q-card-section>
    </q-card>
</template>

<script setup lang="ts">
import type { Product } from "~/models/Product"
//import PrimaryButton from "~/components/PrimaryButton.vue";
//import ProductPrice from "./ProductPrice.vue";
import { ref } from "vue"
import { getCategoriesNames } from "~/common/helpers"
//import TextInput from "~/components/TextInput.vue";
import { useProductCardData } from "~/composables/ProductCardData"
import { useProductPointOfSales } from "~/composables/ProductPointOfSales"
//import ProductLocation from "./ProductLocation.vue";

const props = defineProps<{
    product: Product
    storeType: String
}>()

const emits = defineEmits<{
    (e: "add", product: Product, quantity: number): void
    (e: "show", product: Product, quantity: number): void
}>()

const { slide, ranting, quantity, add, showProduct, inStock } =
    useProductCardData(props.product, props.storeType, emits)
const point_of_sale_list = useProductPointOfSales(props.product)
</script>
